module.exports = __webpack_public_path__ + "static/media/IMG_5045.cff4d853.JPG";